/*
 * Copyright (c) 2021 biocrates life sciences ag, All rights reserved.
 */

export default class TableData<C, R> {
    columns: C[]

    rows: R[]

    constructor(columns: C[] = [], rows: R[] = []) {
        this.columns = columns
        this.rows = rows
    }
}
